// import {area} from "@/utils/areaData";

import {area} from "@/api/areaApi";
import {momentFormat} from "@/utils/util";
import {dateFormat} from "@/config/variableConfig";

/**
 * 区域渲染
 * @param provCode
 * @param cityCode
 * @param distCode
 * @returns {*}
 */
export const areaCustomRender = (provCode, cityCode, distCode) => {
    const prov = area[provCode]
    const city = area[cityCode] || ''
    const dist = area[distCode] || ''
    return (prov + city + dist) || '---'
}

/**
 * 区域渲染
 * @param record
 * @returns {*}
 */
export const defaultAreaCustomRender = ({record}) => {
    return areaCustomRender(record.prov, record.city, record.dist)
}

/**
 * 用户子对象区域渲染
 * @param record
 * @returns {*}
 */
export const customerObjAreaRender = ({record}) => {
    let customerObj = record.customerObj
    return areaCustomRender(customerObj.prov, customerObj.city, customerObj.dist)
}



/**
 * 日期，渲染函数
 * @param dateTime  待格式化的日期
 * @param dateFormat 待格式化的日期格式
 * @param renderFormat 期望的日期格式
 * @returns {string|*|string}
 */
export const dateTimeCustomRender = ({dateTime, dateFormat=null, renderFormat}) => {
    return momentFormat(dateTime, renderFormat, dateFormat)
}

/**
 * 日期+时间，一般用于创建时间的展示
 * @param text
 * @returns {string|*|string}
 */
export const defaultDateTimeCustomRender = ({text}) => {
    return momentFormat(text, dateFormat.TIME_SECOND)
}

/**
 * 日期，一般用于生日等展示，不包含时间
 * @param text
 * @returns {string|*|string}
 */
export const defaultDateCustomRender = ({text}) => {
    return momentFormat(text, dateFormat.DATE_DAY)
}
